var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"big-button",class:[
    {
      answer: _vm.type === 'answer',
    },
    {
      noCaps: !_vm.allCaps,
    } ],attrs:{"data-selectable":_vm.selectable},on:{"click":_vm.onClick}},[(_vm.withImage == null || _vm.withImage == undefined)?_vm._t("default"):_vm._e(),(_vm.withImage != null)?_c('img',{attrs:{"src":_vm.getImage,"alt":"button image"}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }